import moment from 'moment-timezone';
import 'moment/locale/pt';
import 'moment/locale/es';
import 'moment/locale/ru';

import numeral from 'numeral';
import 'numeral/locales/pt-pt';
import 'numeral/locales/es';
import 'numeral/locales/ru';

const momentLocalesMap = {
    'ru-ru': 'ru',
    'pt-pt': 'pt',
    'en-us': 'en'
}

const numeralLocalesMap = {
    'ru-ru': 'ru',
    'pt': 'pt-pt',
    'en-us': 'en'
}

moment.updateLocale('en', {
    relativeTime : {
        future: "in %s",
        past:   "%s ago",
        s  : 'a few secs',
        ss : '%d secs',
        m:  "a min",
        mm: "%d mins",
        h:  "1 hr",
        hh: "%d hrs",
        d:  "1 day",
        dd: "%d days",
        M:  "1 mo",
        MM: "%d mos",
        y:  "1 yr",
        yy: "%d yrs"
    }
});

numeral.fn.USD = function(format) {
    if (arguments.length == 0) {
        format = '0,0[.]00';
    }
    let result = this.format(format) || '';
    
    if (result.startsWith('-')) {
        result = '-$' + result.substr(1);
    }
    else if (result.startsWith('+')) {
        result = '+$' + result.substr(1);
    }
    else if (result) {
        result = '$' + result;
    }

    return result;
}

numeral.fn.PERCENT = function(format) {
    if (arguments.length == 0) {
        format = '0[.]00';
    }
    let result = this.format(format) || '';
    
    if (result) {
        result = result + '%';
    }

    return result;
}

export function setLocaleGlobal(localeId) {
    const id = (localeId || '').toLowerCase() || 'en';
    
    const momentLocaleId = momentLocalesMap[id] || id;
    const numeralLocaleId = numeralLocalesMap[id] || id;

    moment.locale(momentLocaleId);
    numeral.locale(numeralLocaleId);
};